export interface ViewportBreakpoints {
  tabletMinWidth: number;
  desktopMinWidth: number;
  mobileNavMinWidth: number;
}

let breakpoints: ViewportBreakpoints;

/**
 * Reads media queries breakpoints variables from document style
 */
function getBreakpoints(): ViewportBreakpoints {
  // read these on the first use - they won't change over the app lifecycle, but this ensures that they're set from css
  if (!breakpoints) {
    const documentStyle = getComputedStyle(document.documentElement);

    const tabletMinWidth = parseInt(
      documentStyle.getPropertyValue('--breakpoint-tablet-min-width')
    );
    const desktopMinWidth = parseInt(
      documentStyle.getPropertyValue('--breakpoint-desktop-min-width')
    );
    const mobileNavMinWidth = parseInt(
      documentStyle.getPropertyValue('--breakpoint-secondary-nav-min-width')
    );

    breakpoints = {
      tabletMinWidth,
      desktopMinWidth,
      mobileNavMinWidth,
    };
  }

  return breakpoints;
}

export { getBreakpoints };
